import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

// Shared "Show more / Show less" toggle for the truncated booking log tables.
// Renders nothing until there are more than `limit` rows.
function ShowMoreToggle({ total, limit, showAll, onToggle }) {
    const { t } = useTranslation();
    if (total <= limit) return null;
    return (
        <Box sx={{ pt: 1, textAlign: 'center' }}>
            <Typography
                variant="body2"
                color="primary"
                sx={{ cursor: 'pointer' }}
                onClick={onToggle}
            >
                {showAll ? t('common.showLess') : t('common.showMore', { count: total - limit })}
            </Typography>
        </Box>
    );
}

export default ShowMoreToggle;
